import { render, staticRenderFns } from "./EditRestaurantAdmin.vue?vue&type=template&id=4c43ee44"
import script from "./EditRestaurantAdmin.vue?vue&type=script&lang=js"
export * from "./EditRestaurantAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditRestaurantAdmin.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c43ee44')) {
      api.createRecord('4c43ee44', component.options)
    } else {
      api.reload('4c43ee44', component.options)
    }
    module.hot.accept("./EditRestaurantAdmin.vue?vue&type=template&id=4c43ee44", function () {
      api.rerender('4c43ee44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditRestaurantAdmin.vue"
export default component.exports